type ContentDispositionEncoding = {
    charset: string;
    encoded: string;
};

export function decodeFilename(value: string): string {
    const encoding = parseEncoding(value);

    if (!encoding) {
        return value;
    }

    const { charset, encoded } = encoding;

    // We only support UTF-8, which is the common charset per RFC 5987.
    const isUtf8 = charset === 'utf-8' || charset === 'utf8';

    return isUtf8 ? decodeURIComponent(encoded) : encoded;
}

// Parses `charset'language'value` or `charset''value`
// The language part is optional (empty string when omitted).
// The value may contain percent-encoded characters.
function parseEncoding(value: string): ContentDispositionEncoding | undefined {
    const firstQuoteIndex = value.indexOf("'");
    const secondQuoteIndex = firstQuoteIndex >= 0 ? value.indexOf("'", firstQuoteIndex + 1) : -1;
    const hasEncoding = firstQuoteIndex >= 0 && secondQuoteIndex >= 0;

    if (!hasEncoding) {
        return undefined;
    }

    const charset = value.substring(0, firstQuoteIndex).toLowerCase();
    const encoded = value.slice(secondQuoteIndex + 1);

    return { charset, encoded };
}
